import * as v from "valibot";

import { dropMission, missionPaths } from "./mission";
import type { Drop } from "./model";
import { bounds } from "./model";
import { drop as dropType } from "./model";
import { positionEmpty } from "./position";
import { blobToString } from "./world/browser";

export const dropBounds = (drop: Drop) =>
  bounds([
    ...[drop.start, drop.end, drop.drop].filter(_ => !positionEmpty(_)),
    ...missionPaths(dropMission(drop)).flat(),
  ]);

export const decodeDrop = async (blob: Blob) => {
  const { success, output: drop } = v.safeParse(
    dropType,
    JSON.parse(await blobToString(blob)),
  );
  if (!success) return;
  return drop;
};
export const encodeDrop = (drop: Drop) =>
  new Blob([JSON.stringify(drop)], {
    type: "application/json",
  });
